import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../mutation-types';
import ScheduledMessagesAPI from '../../api/scheduledMessages';

export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

export const getters = {
  getUIFlags(_state) {
    return _state.uiFlags;
  },
  getScheduledMessages(_state) {
    return _state.records;
  },
};

export const actions = {
  get: async function getScheduledMessages({ commit }) {
    commit(types.SET_SCHEDULED_MESSAGE_UI_FLAG, { isFetching: true });
    try {
      const response = await ScheduledMessagesAPI.get();
      commit(types.SET_SCHEDULED_MESSAGES, response.data.payload);
    } catch (error) {
      // Ignore error
    } finally {
      commit(types.SET_SCHEDULED_MESSAGE_UI_FLAG, { isFetching: false });
    }
  },
  getMine: async function getMyScheduledMessages({ commit }) {
    commit(types.SET_SCHEDULED_MESSAGE_UI_FLAG, { isFetching: true });
    try {
      const response = await ScheduledMessagesAPI.getMine();
      commit(types.SET_SCHEDULED_MESSAGES, response.data.payload);
    } catch (error) {
      // Ignore error
    } finally {
      commit(types.SET_SCHEDULED_MESSAGE_UI_FLAG, { isFetching: false });
    }
  },
  getByConversation: async function getScheduledMessagesByConversation(
    { commit },
    conversationId
  ) {
    commit(types.SET_SCHEDULED_MESSAGE_UI_FLAG, { isFetching: true });
    try {
      const response =
        await ScheduledMessagesAPI.getByConversation(conversationId);
      commit(types.SET_SCHEDULED_MESSAGES, response.data.payload);
    } catch (error) {
      // Ignore error
    } finally {
      commit(types.SET_SCHEDULED_MESSAGE_UI_FLAG, { isFetching: false });
    }
  },
  getByContact: async function getScheduledMessagesByContact(
    { commit },
    contactId
  ) {
    commit(types.SET_SCHEDULED_MESSAGE_UI_FLAG, { isFetching: true });
    try {
      const response = await ScheduledMessagesAPI.getByContact(contactId);
      commit(types.SET_SCHEDULED_MESSAGES, response.data.payload);
    } catch (error) {
      // Ignore error
    } finally {
      commit(types.SET_SCHEDULED_MESSAGE_UI_FLAG, { isFetching: false });
    }
  },
  create: async function createScheduledMessage({ commit }, messageObj) {
    commit(types.SET_SCHEDULED_MESSAGE_UI_FLAG, { isCreating: true });
    try {
      const response = await ScheduledMessagesAPI.create(messageObj);
      commit(types.ADD_SCHEDULED_MESSAGE, response.data);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_SCHEDULED_MESSAGE_UI_FLAG, { isCreating: false });
    }
  },
  update: async ({ commit }, { id, ...updateObj }) => {
    commit(types.SET_SCHEDULED_MESSAGE_UI_FLAG, { isUpdating: true });
    try {
      const response = await ScheduledMessagesAPI.update(id, updateObj);
      commit(types.EDIT_SCHEDULED_MESSAGE, response.data);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_SCHEDULED_MESSAGE_UI_FLAG, { isUpdating: false });
    }
  },
  delete: async ({ commit }, id) => {
    commit(types.SET_SCHEDULED_MESSAGE_UI_FLAG, { isDeleting: true });
    try {
      await ScheduledMessagesAPI.delete(id);
      commit(types.DELETE_SCHEDULED_MESSAGE, id);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_SCHEDULED_MESSAGE_UI_FLAG, { isDeleting: false });
    }
  },
  cancel: async ({ commit }, id) => {
    commit(types.SET_SCHEDULED_MESSAGE_UI_FLAG, { isUpdating: true });
    try {
      const response = await ScheduledMessagesAPI.cancel(id);
      commit(types.EDIT_SCHEDULED_MESSAGE, response.data);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_SCHEDULED_MESSAGE_UI_FLAG, { isUpdating: false });
    }
  },
};

export const mutations = {
  [types.SET_SCHEDULED_MESSAGE_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },

  [types.ADD_SCHEDULED_MESSAGE]: MutationHelpers.create,
  [types.SET_SCHEDULED_MESSAGES]: MutationHelpers.set,
  [types.EDIT_SCHEDULED_MESSAGE]: MutationHelpers.update,
  [types.DELETE_SCHEDULED_MESSAGE]: MutationHelpers.destroy,
};

export default {
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
};
